<template>
  <div id="login">
    <section class="bannerprincipal">
      <SiteNav v-if="showNav"></SiteNav>
      <div
        v-if="!showNav"
        class="col-12 text-center"
        data-aos="fade-down"
        data-aos-delay="100"
      ></div>
    </section>

    <section id="inicio">
      <div class="herobanner bgamarillo">
        <carousel
          :center="true"
          :loop="true"
          :items="1"
          :autoplay="true"
          :margin="10"
          :dots="false"
          :nav="false"
          :stagePadding="0"
          :autoplaySpeed="1000"
          :responsive="{
            0: { items: 1 },
            600: { items: 1 },
            920: { items: 1 },
          }"
        >


        <div class="row d-flex justify-content-center align-items-center">
            <div class="col-lg-12 d-none d-lg-block">
              <img
                class="img-fluid"
                src="../assets/imgs/arreglalo/slideshow/Banner_01_Arreglalo_Febrero_desk.jpg"
                alt="Arréglalo"
              />
            </div>
            <div class="col-lg-12 d-block d-lg-none">
              <img
                class="img-fluid"
                src="../assets/imgs/arreglalo/slideshow/Banner_01_Arreglalo_Febrero_mobile.jpg"
                alt="Arréglalo"
              />
            </div>
            
          </div>

          <div class="row d-flex justify-content-center align-items-center">
            <div class="col-lg-12 d-none d-lg-block">
              <img
                class="img-fluid"
                src="../assets/imgs/arreglalo/slideshow/Banner_02_Arreglalo_Febrero_desk.jpg"
                alt="Arréglalo"
              />
            </div>
            <div class="col-lg-12 d-block d-lg-none">
              <img
                class="img-fluid"
                src="../assets/imgs/arreglalo/slideshow/Banner_02_Arreglalo_Febrero_mobile.jpg"
                alt="Arréglalo"
              />
            </div>
            
          </div>



        <!-- <div class="row d-flex justify-content-center align-items-center">
            <div class="col-lg-12 d-none d-lg-block">
              <img
                class="img-fluid"
                src="../assets/imgs/arreglalo/slideshow/abril-2024.jpg"
                alt="Arréglalo"
              />
            </div>
            <div class="col-lg-12 d-block d-lg-none">
              <img
                class="img-fluid"
                src="../assets/imgs/arreglalo/slideshow/abril-2024-movil.jpg"
                alt="Arréglalo"
              />
            </div>
            
          </div> -->


          <div class="row d-flex justify-content-center align-items-center">
            <div class="col-lg-6 pb-5">
              <img
                class="img-fluid"
                src="../assets/imgs/arreglalo/slideshow/Heroimg_desk_01.png"
                alt="Arréglalo"
              />
            </div>
            <div
              class="col-lg-6 pb-5 pb-md-3"
              data-aos="fade-left"
              data-aos-delay="200"
            >
              <h1
                class="fXG azuloscuro bold pb-3 ls-1 text-center text-lg-left"
              >
                ¡Encuentra tu sucursal de <br class="d-none d-lg-block" />
                Arréglalo más cercana!
              </h1>
              <p class="text-center text-lg-left">
                <router-link to="/sucursales">
                  <span class="btnrojo fG bolder ls1"> ENCUÉNTRANOS </span>
                </router-link>
              </p>
            </div>
          </div>

          <div class="row d-flex justify-content-center align-items-center">
            <div class="col-lg-6 pb-5">
              <img
                class="img-fluid"
                src="../assets/imgs/arreglalo/slideshow/Heroimg_desk_02.png"
                alt="Arréglalo"
              />
            </div>
            <div
              class="col-lg-6 pb-5 pb-md-3"
              data-aos="fade-left"
              data-aos-delay="200"
            >
              <h1
                class="fXG azuloscuro bold pb-3 ls-1 text-center text-lg-left"
              >
                ¡Encuentra tu sucursal de <br class="d-none d-lg-block" />
                Arréglalo más cercana!
              </h1>
              <p class="text-center text-lg-left">
                <router-link to="/sucursales">
                  <span class="btnrojo fG bolder ls1"> ENCUÉNTRANOS </span>
                </router-link>
              </p>
            </div>
          </div>

          <div class="row d-flex justify-content-center align-items-center">
            <div class="col-lg-6 pb-5">
              <img
                class="img-fluid"
                src="../assets/imgs/arreglalo/slideshow/Heroimg_desk_03.png"
                alt="Arréglalo"
              />
            </div>
            <div
              class="col-lg-6 pb-5 pb-md-3"
              data-aos="fade-left"
              data-aos-delay="200"
            >
              <h1
                class="fXG azuloscuro bold pb-3 ls-1 text-center text-lg-left"
              >
                ¡Encuentra tu sucursal de <br class="d-none d-lg-block" />
                Arréglalo más cercana!
              </h1>
              <p class="text-center text-lg-left">
                <router-link to="/sucursales">
                  <span class="btnrojo fG bolder ls1"> ENCUÉNTRANOS </span>
                </router-link>
              </p>
            </div>
          </div>


        </carousel>
      </div>
    </section>

    <section id="servicios">
      <div class="container-fluid bg-white">
        <div class="row">
          <div
            class="col-8 offset-2 col-md-4 offset-md-4 text-center pt-5 pb-5"
            data-aos="fade"
            data-aos-delay="200"
          >
            <img
              class="img-fluid"
              src="../assets/imgs/arreglalo/headers/H_servicios.png"
              alt="Nuestros Servicios"
            />
          </div>
        </div>
        <div class="row pb-3">
          <div
            class="col-6 col-lg-3 pb-4 text-center"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <img
              class="img-fluid"
              src="../assets/imgs/arreglalo/servicios/ajusta.jpg"
              alt="Ajusta"
            />
            <h2 class="pt-3 pb-0 fG3 rojo bold">AJUSTA</h2>
            <p class="azuloscuro">
              Haz que todo tu guardarropa te quede como un guante; ajustamos la
              cintura, las piernas, la altura... ¡Todo lo que esté fuera de
              lugar!
            </p>
          </div>
          <div
            class="col-6 col-lg-3 pb-4 text-center"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            <img
              class="img-fluid"
              src="../assets/imgs/arreglalo/servicios/repara.jpg"
              alt="Ajusta"
            />
            <h2 class="pt-3 pb-0 fG3 rojo bold">REPARA</h2>
            <p class="azuloscuro">
              Dale una segunda oportunidad a tus prendas. Cambia esos viejos
              vestidos y jeans y ponles parches creativos.
            </p>
          </div>
          <div
            class="col-6 col-lg-3 pb-4 text-center"
            data-aos="fade-up"
            data-aos-delay="400"
          >
            <img
              class="img-fluid"
              src="../assets/imgs/arreglalo/servicios/personaliza.jpg"
              alt="Ajusta"
            />
            <h2 class="pt-3 pb-0 fG3 rojo bold">PERSONALIZA</h2>
            <p class="azuloscuro">
              Que tu ropa refleje tu estilo único. Intervenimos tus prendas con
              apliques, parches, cintas decorativas y lo que te haga destacar.
            </p>
          </div>
          <div
            class="col-6 col-lg-3 pb-4 text-center"
            data-aos="fade-up"
            data-aos-delay="500"
          >
            <img
              class="img-fluid"
              src="../assets/imgs/arreglalo/servicios/crea.jpg"
              alt="Ajusta"
            />
            <h2 class="pt-3 pb-0 fG3 rojo bold">CREA</h2>
            <p class="azuloscuro">
              Transformamos tu ropa vieja o pasada de moda en algo nuevo. O
              puedes sacar tu fashionista interior y diseñar algo totalmente
              desde cero, ¡nosotros lo hacemos posible!
            </p>
          </div>
        </div>

        <div class="row pb-5">
          <div class="col-10 offset-1 col-lg-8 offset-lg-2">
            <div
              class="bannerazul bgazuloscuro row text-center p-3 d-flex justify-content-center align-items-center"
            >
              <div class="col-md-7 pb-3 pb-lg-0 border-lg-right">
                <span class="fG3 blanco bold"> ¿BUSCABAS ALGO MÁS? </span>
                <br />
                <span class="blanco fR">
                  Conoce nuestra oferta de servicios completa
                </span>
              </div>
              <div class="col-md-5">
                <router-link to="/servicios" class="btnblanco naranja bold fM">
                  DA CLIC AQUÍ
                </router-link>
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="sucursales" class="sucursales">
      <div class="">
        <div class="row d-flex justify-content-end align-items-end">
          <div class="col-lg-5 pb-5" data-aos="fade-right" data-aos-delay="200">
            <p>
              <img
                class="img-fluid"
                src="../assets/imgs/arreglalo/headers/H_directorio.png"
                alt="Sucursales"
              />
            </p>
            <p
              class="fXG azuloscuro bold pb-3 ls-1 text-center text-lg-right d-none d-md-block"
            >
              ¡Encuentra tu sucursal de <br class="d-none d-xl-block" />
              Arréglalo más cercana!
            </p>
            <p
              class="fXG blanco bold pb-3 ls-1 text-center text-lg-right d-block d-md-none"
            >
              ¡Encuentra tu sucursal de <br class="d-none d-xl-block" />
              Arréglalo más cercana!
            </p>
            <p class="text-center text-lg-right mb-5">
              <router-link to="/sucursales">
                <span class="btnrojo fG bolder ls1"> ENCUÉNTRANOS </span>
              </router-link>
            </p>
          </div>

          <div class="col-lg-7 d-none d-md-block">
            <img
              class="w-100"
              src="../assets/imgs/arreglalo/sucursales/arreglalo-sucursales.jpg"
              alt="Sucursales"
            />
          </div>
        </div>
      </div>
    </section>

    <section id="faqs">
      <div class="bg-white">
        <div class="row pt-5" data-aos="fade" data-aos-delay="200">
          <div class="col-12 col-md-4 offset-md-4 text-center pt-5 pb-4">
            <img
              class="img-fluid"
              src="../assets/imgs/arreglalo/headers/H_faq.png"
              alt="Nuestros Servicios"
            />
          </div>
          <div class="col-12 text-center pb-5 px-4">
            <p class="azuloscuro fG bold">
              Te resolvemos algunas de las dudas más frecuentes:
            </p>
          </div>
        </div>
        <div class="row pb-5 px-4">
          <div
            class="col-12 col-lg-12 pb-4 text-left"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <div class="accordion row" role="tablist">
              <b-card no-body class="mb-3 col-md-6">
                <b-card-header
                  header-tag="header"
                  class="p-1 azuloscuro bold"
                  role="tab"
                >
                  <b-button block v-b-toggle.accordion-1 variant="info">
                    <span class="txt">
                      ¿Se pueden facturar sus servicios?
                    </span>
                    <span class="icon">
                      <img
                        width="10"
                        src="../assets/imgs/arreglalo/icons/flecha-right.svg"
                        alt="flecha"
                      />
                    </span>
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-1"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      Sí, todos nuestros servicios se pueden facturar.
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-3 col-md-6">
                <b-card-header
                  header-tag="header"
                  class="p-1 azuloscuro bold"
                  role="tab"
                >
                  <b-button block v-b-toggle.accordion-2 variant="info">
                    <span class="txt"> ¿Aceptan pagos con tarjeta? </span>
                    <span class="icon">
                      <img
                        width="10"
                        src="../assets/imgs/arreglalo/icons/flecha-right.svg"
                        alt="flecha"
                      />
                    </span>
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-2"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      Todas nuestras sucursales cuentan con esa opción de pago.
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-3 col-md-6">
                <b-card-header
                  header-tag="header"
                  class="p-1 azuloscuro bold"
                  role="tab"
                >
                  <b-button block v-b-toggle.accordion-3 variant="info">
                    <span class="txt"> ¿Dónde se encuentran ubicados? </span>
                    <span class="icon">
                      <img
                        width="10"
                        src="../assets/imgs/arreglalo/icons/flecha-right.svg"
                        alt="flecha"
                      />
                    </span>
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-3"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      Tenemos presencia en gran parte de la República. Para
                      mayor detalle, puedes revisar nuestra <router-link to="/sucursales">lista de sucursales</router-link> .
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-3 col-md-6">
                <b-card-header
                  header-tag="header"
                  class="p-1 azuloscuro bold"
                  role="tab"
                >
                  <b-button block v-b-toggle.accordion-4 variant="info">
                    <span class="txt">
                      ¿Me pueden enviar la cotización de un servicio?
                    </span>
                    <span class="icon">
                      <img
                        width="10"
                        src="../assets/imgs/arreglalo/icons/flecha-right.svg"
                        alt="flecha"
                      />
                    </span>
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-4"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      Para darle una cotización exacta le recomendamos acudir a
                      su sucursal Arréglalo, para que revisemos su prenda, a fin
                      de ofrecerle las opciones de arreglo; costo del servicio y
                      la fecha de entrega.
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-3 col-md-6">
                <b-card-header
                  header-tag="header"
                  class="p-1 azuloscuro bold"
                  role="tab"
                >
                  <b-button block v-b-toggle.accordion-5 variant="info">
                    <span class="txt"> ¿Cuál es el horario de servicio? </span>
                    <span class="icon">
                      <img
                        width="10"
                        src="../assets/imgs/arreglalo/icons/flecha-right.svg"
                        alt="flecha"
                      />
                    </span>
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-5"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      La gran mayoría de nuestras sucursales operan de lunes a
                      viernes de 10:00 a 19:00 horas, y sábados de 10:00 a 18:00
                      horas. Le recomendamos consultar nuestra lista de
                      sucursales
                      <router-link
                        class="underlined bold azuloscuro"
                        to="/sucursales"
                        >aquí.</router-link
                      >
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-3 col-md-6">
                <b-card-header
                  header-tag="header"
                  class="p-1 azuloscuro bold"
                  role="tab"
                >
                  <b-button block v-b-toggle.accordion-6 variant="info">
                    <span class="txt"> ¿Arreglan vestidos de novia? </span>
                    <span class="icon">
                      <img
                        width="10"
                        src="../assets/imgs/arreglalo/icons/flecha-right.svg"
                        alt="flecha"
                      />
                    </span>
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-6"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      Sí, el personal de nuestras tiendas está capacitado para
                      hacer arreglos en alta costura.
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-3 col-md-6">
                <b-card-header
                  header-tag="header"
                  class="p-1 azuloscuro bold"
                  role="tab"
                >
                  <b-button block v-b-toggle.accordion-7 variant="info">
                    <span class="txt"> ¿Arreglan trajes de caballero? </span>
                    <span class="icon">
                      <img
                        width="10"
                        src="../assets/imgs/arreglalo/icons/flecha-right.svg"
                        alt="flecha"
                      />
                    </span>
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-7"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      Sí, el personal de nuestras tiendas está capacitado para
                      hacer arreglos de sastrería.
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-3 col-md-6">
                <b-card-header
                  header-tag="header"
                  class="p-1 azuloscuro bold"
                  role="tab"
                >
                  <b-button block v-b-toggle.accordion-8 variant="info">
                    <span class="txt"> ¿Arreglan prendas de piel? </span>
                    <span class="icon">
                      <img
                        width="10"
                        src="../assets/imgs/arreglalo/icons/flecha-right.svg"
                        alt="flecha"
                      />
                    </span>
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-8"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      Sí, el personal de nuestras tiendas está capacitado para
                      hacer arreglos en prendas de piel. (Aplican restricciones
                      con las prendas de piel de pelo.)
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-3 col-md-6">
                <b-card-header
                  header-tag="header"
                  class="p-1 azuloscuro bold"
                  role="tab"
                >
                  <b-button block v-b-toggle.accordion-9 variant="info">
                    <span class="txt">
                      ¿Confeccionan prendas a la medida?
                    </span>
                    <span class="icon">
                      <img
                        width="10"
                        src="../assets/imgs/arreglalo/icons/flecha-right.svg"
                        alt="flecha"
                      />
                    </span>
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-9"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      Se realizan principalmente confecciones de blancos y en
                      algunas sucursales se pueden realizar confecciones
                      básicas.
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-3 col-md-6">
                <b-card-header
                  header-tag="header"
                  class="p-1 azuloscuro bold"
                  role="tab"
                >
                  <b-button block v-b-toggle.accordion-10 variant="info">
                    <span class="txt"> ¿Hacen trabajos urgentes? </span>
                    <span class="icon">
                      <img
                        width="10"
                        src="../assets/imgs/arreglalo/icons/flecha-right.svg"
                        alt="flecha"
                      />
                    </span>
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-10"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      Sí, se entregan arreglos sencillos dentro de una hora,
                      como dobladillos en máquina o mano, repasos de costura,
                      reforzar botones, cierres y rotos pequeños.
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-3 col-md-6">
                <b-card-header
                  header-tag="header"
                  class="p-1 azuloscuro bold"
                  role="tab"
                >
                  <b-button block v-b-toggle.accordion-11 variant="info">
                    <span class="txt"> ¿Tienen servicio de planchado? </span>
                    <span class="icon">
                      <img
                        width="10"
                        src="../assets/imgs/arreglalo/icons/flecha-right.svg"
                        alt="flecha"
                      />
                    </span>
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-11"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      Sí, algunas de nuestras sucursales se ofrce el servicio de
                      planchado.
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-3 col-md-6">
                <b-card-header
                  header-tag="header"
                  class="p-1 azuloscuro bold"
                  role="tab"
                >
                  <b-button block v-b-toggle.accordion-12 variant="info">
                    <span class="txt">
                      ¿Cuánto tiempo tardan en entregar mi arreglo?
                    </span>
                    <span class="icon">
                      <img
                        width="10"
                        src="../assets/imgs/arreglalo/icons/flecha-right.svg"
                        alt="flecha"
                      />
                    </span>
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-12"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      Depende de la complejidad del servicio o la dificultad
                      para conseguir algún material especial. En general tenemos
                      trabajos de entrega inmediata o hasta cinco días.
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-3 col-md-6">
                <b-card-header
                  header-tag="header"
                  class="p-1 azuloscuro bold"
                  role="tab"
                >
                  <b-button block v-b-toggle.accordion-13 variant="info">
                    <span class="txt">
                      Perdí mi ticket, ¿me pueden entregar mi ropa sin él?
                    </span>
                    <span class="icon">
                      <img
                        width="10"
                        src="../assets/imgs/arreglalo/icons/flecha-right.svg"
                        alt="flecha"
                      />
                    </span>
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-13"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      Sí, para esto es necesario que acuda a la sucursal y le
                      muestre a la Encargada de la tienda una identificación.
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-3 col-md-6">
                <b-card-header
                  header-tag="header"
                  class="p-1 azuloscuro bold"
                  role="tab"
                >
                  <b-button block v-b-toggle.accordion-14 variant="info">
                    <span class="txt">
                      ¿Por qué varían los precios entre un arreglo y otro?
                    </span>
                    <span class="icon">
                      <img
                        width="10"
                        src="../assets/imgs/arreglalo/icons/flecha-right.svg"
                        alt="flecha"
                      />
                    </span>
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-14"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      Todos nuestros servicios son artesanales, es decir,
                      ninguno es igual al otro, y por la gran variedad que
                      ofrecemos (más de 2 mil diferentes tipos de arreglos) así
                      como la especialización de cada uno de ellos, nos es
                      imposible tener una lista de precios establecida bajo un
                      solo criterio, adicionado a la preferencia del cliente.
                      Estas son las razones principales del porque se maneja una
                      lista de precio “DESDE” y se cotiza cada servicio antes de
                      que el cliente acepte al elaboración del servicio.
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-3 col-md-6">
                <b-card-header
                  header-tag="header"
                  class="p-1 azuloscuro bold"
                  role="tab"
                >
                  <b-button block v-b-toggle.accordion-15 variant="info">
                    <span class="txt">
                      ¿Cuánto tiempo tardan en entregarme los arreglos?
                    </span>
                    <span class="icon">
                      <img
                        width="10"
                        src="../assets/imgs/arreglalo/icons/flecha-right.svg"
                        alt="flecha"
                      />
                    </span>
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-15"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      Depende de la complejidad del servicio o la dificultad
                      para conseguir algún material especial. En general tenemos
                      trabajos de entrega inmediata o hasta cinco días.
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-3 col-md-6">
                <b-card-header
                  header-tag="header"
                  class="p-1 azuloscuro bold"
                  role="tab"
                >
                  <b-button block v-b-toggle.accordion-16 variant="info">
                    <span class="txt">
                      ¿Qué es lo que debo esperar de Arréglalo?
                    </span>
                    <span class="icon">
                      <img
                        width="10"
                        src="../assets/imgs/arreglalo/icons/flecha-right.svg"
                        alt="flecha"
                      />
                    </span>
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-16"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      En Arréglalo nuestros clientes obtienen un servicio
                      moderno, rápido y profesional de arreglos de ropa, en
                      instalaciones equipadas y con personal altamente
                      calificado que sabrá cubrir sus expectativas, garantizando
                      el mejor servicio y calidad.
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-3 col-md-6">
                <b-card-header
                  header-tag="header"
                  class="p-1 azuloscuro bold"
                  role="tab"
                >
                  <b-button block v-b-toggle.accordion-17 variant="info">
                    <span class="txt"> ¿Qué otros servicios realizan? </span>
                    <span class="icon">
                      <img
                        width="10"
                        src="../assets/imgs/arreglalo/icons/flecha-right.svg"
                        alt="flecha"
                      />
                    </span>
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-17"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                     

                      <p>
                        Contamos con una gama amplia de servicios, como por
                        ejemplo:
                      </p>
                      <ul class="bullets">
                        <li>
                          Modificaciones, transformación y renovación de prendas
                        </li>
                        <li>Sastrería</li>
                        <li>Alta costura</li>
                        <li>Bordados personalizados</li>
                        <li>Etiquetas personalizadas</li>
                        <li>Arreglos en prendas de piel</li>
                        <li>Receptoría de Tintorería y Planchado</li>
                      </ul>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>

              <b-card no-body class="mb-3 col-md-6">
                <b-card-header
                  header-tag="header"
                  class="p-1 azuloscuro bold"
                  role="tab"
                >
                  <b-button block v-b-toggle.accordion-18 variant="info">
                    <span class="txt">
                      ¿Con quién me puedo comunicar en caso de tener un problema
                      en alguna sucursal?
                    </span>
                    <span class="icon">
                      <img
                        width="10"
                        src="../assets/imgs/arreglalo/icons/flecha-right.svg"
                        alt="flecha"
                      />
                    </span>
                  </b-button>
                </b-card-header>
                <b-collapse
                  id="accordion-18"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      Para Arréglalo la satisfacción de nuestros clientes es lo
                      más importante, si usted tiene algún problema en alguna de
                      nuestras sucursales puede llamar al teléfono
                      <a
                        class="bold azuloscuro underlined"
                        href="tel:56 3472 5284"
                        >(55) 56 3472 5284</a
                      >, o llenar el formulario con el cual en seguida nos
                      comunicaremos con usted
                      <span
                        class="underlined pointer bold"
                        @click="toggleOverlay()"
                        >Contáctanos aquí</span
                      >..
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="emprende">
      <div class="">
        <div class="row d-flex align-items-end">
          <div
            class="col-lg-6 pb-5 order-2 order-md-1"
            data-aos="fade-right"
            data-aos-delay="200"
          >
            <div class="row">
              <div class="col-10 offset-1 col-md-9 offset-md-3">
                <p
                  class="blanco fG2 bolder pt-lg-5 text-center text-md-right pb-3"
                >
                  Invierte en un modelo de franquicia inteligente con una
                  inversión mínima y un bajo costo de producción. Genera
                  ingresos adicionales de manera eficiente con una inversión
                  baja y un ROI predecible y escalable.
                </p>
                <div class="text-center text-lg-right mb-5">
                  <router-link to="/emprende">
                    <span class="btnrojo fG bolder ls1"> SABER MÁS </span>
                  </router-link>
                </div>
              </div>
            </div>
          </div>

          <div
            class="col-lg-6 text-center text-md-right pb-md-5 order-1 order-md-2"
            data-aos="fade-left"
            data-aos-delay="200"
          >
            <div class="row pb-md-5">
              <div class="col-10 offset-1 col-md-9 offset-md-3 pb-md-5">
                <p>
                  <img
                    class="img-fluid"
                    src="../assets/imgs/arreglalo/headers/H_emprende.png"
                    alt="Sucursales"
                  />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer></Footer>

    <div class="overlay" v-if="$store.state.overlay == true">
      <div class="overlaybg" @click="toggleOverlay()"></div>
      <div class="overlay-contenido">
        <div class="container">
          <div class="row">
            <div class="col-12 rounded shadow py-4 contbtn bgazul">
              <div class="btncerrar" @click="toggleOverlay()">
                <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M 7.21875 5.78125 L 5.78125 7.21875 L 14.5625 16 L 5.78125 24.78125 L 7.21875 26.21875 L 16 17.4375 L 24.78125 26.21875 L 26.21875 24.78125 L 17.4375 16 L 26.21875 7.21875 L 24.78125 5.78125 L 16 14.5625 Z"
                  />
                </svg>
              </div>

              <div class="row">
                <div class="col-12 text-center fG2 blanco bold pb-4">
                  Déjanos tus datos y en breve nos podremos en contacto.
                </div>

                <div class="col-10 offset-1 blanco">
                  <form @submit="submitFormulario($event)">
                    <label>
                      <span>Tu nombre:</span>
                      <input
                        type="text"
                        v-model="signupForm.nombre"
                        placeholder="Tu nombre"
                        required
                      />
                    </label>
                    <label>
                      <span>Tu correo electrónico:</span>
                      <input
                        type="email"
                        v-model="signupForm.email"
                        placeholder="Tu correo electrónico"
                        required
                      />
                    </label>
                    <label>
                      <span>Tu teléfono:</span>
                      <input
                        type="tel"
                        pattern="[0-9]{10}"
                        title="Introduce un teléfono válido."
                        v-model="signupForm.telefono"
                        placeholder="Tu teléfono"
                        required
                      />
                    </label>

                    <label class="text-center">
                      <button type="submit" class="btnblanco d-inline-block">
                        ENVIAR
                      </button>
                    </label>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SiteNav from "@/components/SiteNav";
import PasswordReset from "@/components/PasswordReset";

import router from "../router/index";

import Footer from "@/components/Footer";
import AOS from "aos";
import swal from "sweetalert2";

import { mapState } from "vuex";

import carousel from "vue-owl-carousel";

export default {
  components: {
    Footer,
    SiteNav,
    carousel,
  },
  data() {
    return {
      mensaje_reenvio: "",
      torneo_db: false,
      clinica_db: false,
      comida_db: false,
      reenvioForm: {
        codigo: "",
      },
      loginForm: {
        no_cliente: "",
        password: "",
      },
      preForm: {
        codigo: "",
        apellido_paterno: "",
        email: "",
      },
      signupForm: {
        nombre: "",
        email: "",
        telefono: "",
      },
      showLoginForm: true,
      showPasswordReset: false,
      showMonedero: false,
      dateType: "text",
      explotar: true,
      id: null,
      guia: false,
    };
  },
  name: 'Inicio',
  metaInfo: {
    title: 'Inicio | Arréglalo', // Sets the page title
    meta: [
      {
        name: 'description',
        content: 'Centros de Costura',
      },
    ],
  },
  mounted: function () {
    AOS.init({
      offset: -100, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: true, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });
    this.id = this.$route.params.id;
    console.log({ id: this.id });

    if (this.id != undefined) {
      this.traeDatos();
    }
  },
  computed: {
    ...mapState(["userProfile"]),
    showNav() {
      //return Object.keys(this.userProfile).length > 1;
      return true;
    },
  },
  methods: {
    traeDatos() {
      console.log("datos iniciales");
      const https = require("https");
      var qData = {
        codigo: this.id,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "datos-iniciales.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.preForm.codigo = res.datos[0].codigo;
              this.preForm.apellido_paterno = res.datos[0].apellido_paterno;
              this.preForm.email = res.datos[0].email;
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    nuevocodigo() {
      this.reenvioForm.codigo = "";
    },
    cambiaFechaType() {
      this.dateType = "date";
      if (this.signupForm.fecha_nacimiento == "")
        this.signupForm.fecha_nacimiento = "1900-01-01";
    },
    toggleForm() {
      this.showLoginForm = !this.showLoginForm;
    },
    togglePasswordReset() {
      this.showPasswordReset = !this.showPasswordReset;
    },
    submitFormulario(e) {
      this.$store.dispatch("showLoader", true);

      e.preventDefault();

      const https = require("https");
      var qData = this.signupForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "registro.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("res login");
            console.log(response);

            let res = response.body;

            if (res.status == "ok") {
              this.toggleOverlay();

              this.signupForm = {
                nombre: "",
                email: "",
                telefono: "",
              };

              swal.fire("Datos registrados", res.msg, "success");
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    presignup(e) {
      e.preventDefault();

      console.log({ presignup: this.preForm });

      this.$store.dispatch("showLoader", true);

      let thes = this;
      const https = require("https");
      var qData = this.preForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "presignup.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio presingup");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              //swal.fire("Bien", res.msg, "success");

              console.log(res.datos);
              console.log(res.datos[0].codigo);
              console.log(res.datos[0].email);

              this.signupForm.codigo = res.datos[0].codigo;
              this.signupForm.email_user = res.datos[0].email;
              this.signupForm.nombre_1 = res.datos[0].nombre_1.toUpperCase();
              this.signupForm.nombre_2 = res.datos[0].nombre_2.toUpperCase();
              this.signupForm.apellido_paterno =
                res.datos[0].apellido_paterno.toUpperCase();
              this.signupForm.apellido_materno =
                res.datos[0].apellido_materno.toUpperCase();
              this.signupForm.empresa = res.datos[0].empresa.toUpperCase();
              this.signupForm.puesto = res.datos[0].puesto.toUpperCase();
              this.signupForm.telefono = res.datos[0].telefono;
              this.signupForm.movil = res.datos[0].movil;

              if (res.datos[0].tipo == "PATROCINADOR") {
                //
                this.signupForm.clinica = res.datos[0].clinica;
                this.signupForm.torneo = res.datos[0].torneo;
                this.signupForm.comida = res.datos[0].comida;
                this.signupForm.tipo = res.datos[0].tipo;

                this.torneo_db = res.datos[0].torneo;
                this.clinica_db = res.datos[0].clinica;
                this.comida_db = res.datos[0].comida;

                if (this.signupForm.torneo == "SI") {
                  this.signupForm.evento = "Torneo";
                }
                if (this.signupForm.clinica == "SI") {
                  this.signupForm.evento = "Clínica";
                }
              }

              this.preForm = {
                codigo: "",
                apellido_paterno: "",
                email: "",
              };
            } else if (res.status === "reenvio") {
              this.reenvioForm.codigo = res.codigo_reenvio;
              this.mensaje_reenvio = res.msg;

              this.preForm = {
                codigo: "",
                apellido_paterno: "",
                email: "",
              };
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    reenvio() {
      console.log({ reenvio: this.reenvioForm });

      this.$store.dispatch("showLoader", true);

      let thes = this;
      const https = require("https");
      var qData = this.reenvioForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "reenvio.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio reenvio");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    signup(e) {
      e.preventDefault();

      console.log({ registro: this.signupForm });
      this.enviaRegistro();
    },
    async enviaRegistro() {
      this.$store.dispatch("showLoader", true);

      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");
      var qData = this.signupForm;

      this.$http
        .post(
          process.env.VUE_APP_API_URL + "registro.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            this.$store.dispatch("showLoader", false);
            console.log("envio registro");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              swal.fire("Bien", res.msg, "success");
              this.resetForm();
            } else {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          (error) => {
            // error callback
            this.$store.dispatch("showLoader", false);
            console.log("error callback");
            console.log(error);
          }
        );
    },
    resetForm() {
      this.signupForm = {
        codigo: "",
        nombre_1: "",
        nombre_2: "",
        apellido_paterno: "",
        apellido_materno: "",
        empresa: "",
        puesto: "",
        email_user: "",
        codigo_pais: "",
        telefono: "",
        movil: "",
        torneo: false,
        handicap: "",
        talla_tops: "",
        clinica: false,
        talla_zapatos: "",
        talla_guantes: "",
        horario_clinica: "",
        talla_cubrebocas: "",
        terminos: false,
        evento: "",
      };
    },
    validPass(password) {
      if (password.length < 8) {
        return false;
      }
      return true;
    },
    validPhone(celular) {
      if (celular.length < 10) {
        return false;
      }
      if (isNaN(celular)) {
        return false;
      }

      return true;
    },
    changeEvento(e) {
      if (this.signupForm.evento == "Clínica") {
        this.signupForm.clinica = "SI";
        this.signupForm.torneo = "NO";
      } else if (this.signupForm.evento == "Torneo") {
        this.signupForm.clinica = "NO";
        this.signupForm.torneo = "SI";
      } else if (this.signupForm.evento == "Ninguno") {
        this.signupForm.clinica = "NO";
        this.signupForm.torneo = "NO";
      }
      this.signupForm.talla_zapatos = "";
      this.signupForm.talla_guantes = "";
      this.signupForm.handicap = "";
      this.signupForm.talla_tops = "";
    },
    changeComida(e) {
      if (this.signupForm.comida == "NO") {
        this.signupForm.torneo = "NO";
        this.signupForm.clinica = "NO";
      }
      this.signupForm.handicap = "";
    },
    changeTorneo(e) {
      if (this.signupForm.torneo === "SI") {
        this.signupForm.clinica = "NO";
        this.signupForm.talla_zapatos = "";
        this.signupForm.talla_guantes = "";
      } else {
        this.signupForm.handicap = "";
        this.signupForm.talla_tops = "";
        this.signupForm.talla_zapatos = "";
      }
    },
    changeClinica(e) {
      if (this.signupForm.clinica === "SI") {
        this.signupForm.torneo = "NO";
        this.signupForm.handicap = "";
        this.signupForm.talla_tops = "";
      } else {
        this.signupForm.talla_zapatos = "";
        this.signupForm.talla_guantes = "";
      }
    },
    toggleOverlay() {
      this.$store.state.overlay = !this.$store.state.overlay;

      console.log({ click: this.$store.state.overlay });
    },
  },
};
</script>
